import { render } from "./StripePaymentMethodWidget.vue?vue&type=template&id=b509a38a"
import script from "./StripePaymentMethodWidget.vue?vue&type=script&lang=js"
export * from "./StripePaymentMethodWidget.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__